import { MetaData, EventsPage } from '@/components'
import {
  fetchAreaEvents,
  fetchAreaInfo,
  getAreaInfoById,
} from '@/store/slices/stagesSlice/stagesSlice'
import { initializeStore } from '@/store'
import { NextPage } from 'next'

const NextEventsPage: NextPage<{ areaId: string; number: string | null }> = ({
  areaId,
  number,
}) => {
  return (
    <>
      <MetaData />
      <EventsPage areaId={areaId} number={number} />
    </>
  )
}

NextEventsPage.getInitialProps = async ({ query }) => {
  const areaId: string = query.areaId as string
  const number: string | null = (query.number || null) as string | null
  const reduxStore = initializeStore()
  const { dispatch, getState } = reduxStore

  await dispatch(fetchAreaEvents({ areaId }))

  const response = getAreaInfoById(getState(), areaId)
  if (!response.data) {
    await dispatch(fetchAreaInfo({ id: areaId }))
  }

  return {
    initialReduxState: reduxStore.getState(),
    areaId,
    number,
    headerLayout: 'back',
  }
}

export default NextEventsPage
